import { render, staticRenderFns } from "./Geschiedenis.vue?vue&type=template&id=d1840612&scoped=true"
import script from "./Geschiedenis.vue?vue&type=script&lang=js"
export * from "./Geschiedenis.vue?vue&type=script&lang=js"
import style0 from "./Geschiedenis.vue?vue&type=style&index=0&id=d1840612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1840612",
  null
  
)

export default component.exports